<template>
  <v-toolbar app height=80 dark color="blue">
    <v-toolbar-title to="/">Moben</v-toolbar-title>

    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat v-if="this.$localStorage.signedIn">
        <v-icon class="pr-1">fa-user</v-icon> {{ this.$localStorage.email }}
      </v-btn>
      <v-btn flat @click="signOut" v-if="this.$localStorage.signedIn">
        <v-icon class="pr-1">fa-sign-out-alt</v-icon> Uitloggen
      </v-btn>            
    </v-toolbar-items>

    <v-menu class="hidden-md-and-up">
      <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
      <v-list>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title><v-icon class="pr-1">fa-user</v-icon>{{ email }}</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="email">
          <v-list-tile-content>
            <v-list-tile-title @click="signOut"><v-icon>fa-sign-out-alt</v-icon>Uitloggen</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>    
  </v-toolbar>
</template>

<script>
export default {
  name: 'Header',
  data: () => ({
    email: localStorage.email
  }),
  methods: {
    signOut () {
      this.$localStorage.email = null
      this.$localStorage.access = null
      this.$localStorage.signedIn = false
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>
</style>